import '../types';
import { genId } from '../utils/utils';
export var UIElementTypes;
(function (UIElementTypes) {
    UIElementTypes["RECT"] = "RECT";
    UIElementTypes["TEXT"] = "TEXT";
    UIElementTypes["BUTTON"] = "BUTTON";
    UIElementTypes["TRIANGLE"] = "TRIANGLE";
    UIElementTypes["SLIDER"] = "SLIDER";
})(UIElementTypes || (UIElementTypes = {}));
export class UIElement {
    constructor(uiElementType, x, y, z, name, id) {
        this.uiElementType = uiElementType;
        this.x = x;
        this.y = y;
        this.z = z;
        this.name = name;
        this.eventsToListen = [
            'modified',
            'scaled',
            'moving',
        ];
        this.id = id || genId();
    }
}
